<ui-dropdown class="h-100 d-flex align-items-center">
    <div class="d-flex align-items-center justify-content-center h-100 gap-10" drop-trigger>
        <div class="d-flex flex-column align-items-center justify-content-center">
            <span class="nome">
                {{ nomeUsuario?.toUpperCase() }}
            </span>
        </div>
        <span class="icon">
            {{ (nomeUsuario ?? 'U').charAt(0)?.toUpperCase() }}
        </span>
    </div>
    <ui-drop-item (click)="logout()">
        <i class="fa fa-arrow-left"></i>Sair da sessão
    </ui-drop-item>
</ui-dropdown>
